import useSWR from "swr"

import fetchLockingSystemPreviewProducts from "@secureo/common/utils/commerceTools/graphql/queries/fetchLockingSystemPreviewProducts"
import { LockingSystemPreviewProductsByTypeBySku } from "@secureo/common/typings/LockingSystem"
import { CurrencyCode } from "@secureo/common/typings/Forex"

const fallbackData: LockingSystemPreviewProductsByTypeBySku = {
	accessory: {},
	lock: {},
	key: {},
}

const useLockingSystemPreviewProducts = (
	accessToken: string,
	lockingSystemCategoryId: string,
	currencyCode: CurrencyCode,
) => {
	const { data: lockingSystemPreviewProductsByTypeBySku, error } = useSWR(
		accessToken && lockingSystemCategoryId
			? [accessToken, lockingSystemCategoryId, currencyCode]
			: null,
		([accessToken, lockingSystemCategoryId, currencyCode]) =>
			fetchLockingSystemPreviewProducts(accessToken, lockingSystemCategoryId, currencyCode),
		{
			fallbackData,
			revalidateOnMount: true,
		},
	)

	return { lockingSystemPreviewProductsByTypeBySku, error }
}

export default useLockingSystemPreviewProducts
